import React, { useContext, useState, useEffect, useRef, useCallback } from 'react';
import { Box, Container, useMediaQuery, Stack } from '@mui/material';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRightRounded';
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import SwiperCarousel from '../shared/SwiperCarousel';
import EirOfferCard from './EirOfferCard';
// import { MobileOfferContext } from '../eir-mobile-offer-container/mobile.context';
import RootContext from '../../../util/root.context';
import useMaxHeightCard from './offer-cart.util';
import EirSingleOfferCard from './EirSingleOfferCard';
import useLocalStorage from '../../hooks/useLocalStorage';

import styles from './styles';

const { publicRuntimeConfig } = getConfig();
const EirOfferCardContainer = ({
  billpaySkeleton,
  offers,
  loading = true,
  onOfferSelect,
  onOfferUnSelect,
  addingTariff,
  selectedBundle,
  showLoader,
  simOnly = false,
  // isStandAloneHandset,
  cmsData,
  // fadeEffect,
}) => {
  const router = useRouter();
  const [offerCardSelected, setOfferCardSelected] = useState([]);
  const [leftArrowDisabled, setLeftArrowDisabled] = useState(true);
  const [RightArrowDisabled, setRightArrowDisabled] = useState(false);
  // const { state } = useContext(MobileOfferContext);
  const defaultStates = useContext(RootContext);
  const localStore = useLocalStorage();
  const useMaxHeight = useMaxHeightCard();
  const swiperRef = useRef(null);
  const theme = useTheme();
  const style = styles(theme);
  const md = useMediaQuery(theme.breakpoints.down('md'));
  const xs = useMediaQuery(theme.breakpoints.down('sm'));
  const handleOnMobileOfferSelect = (index, offer) => {
    // setOfferCardSelected([offer.code]);
    if (localStore.getLocalStorage('STANDALONE_HANDSET')) {
      if (!addingTariff) setOfferCardSelected([offer.code]);
      onOfferSelect(offer, simOnly);
    } else {
      const setSelected = (status = false) => {
        if (status) setOfferCardSelected([offer.code]);
      };
      onOfferSelect(offer, simOnly, setSelected);
    }
  };
  const handleOnMobileOfferUnselect = (index, offer) => {
    if (localStore.getLocalStorage('STANDALONE_HANDSET')) {
      setOfferCardSelected(offerCardSelected?.filter(item => offer.code !== item));
      onOfferUnSelect();
    }
    // setOfferCardSelected(offerCardSelected?.filter(item => offer.code !== item));
    else {
      const setUnSelected = status => {
        if (status) setOfferCardSelected(offerCardSelected?.filter(item => offer.code !== item));
      };
      onOfferUnSelect(setUnSelected);
    }
  };

  const selectedCheck = offerCode => {
    if (defaultStates.state.cart === null) return 0;
    if (localStore.getLocalStorage('STANDALONE_HANDSET')) {
      return defaultStates.state.cart?.offers?.filter(
        offer => offer.id === localStore.getLocalStorage('HANDSET_BE_OFFERID')
      ).length;
    }
    return defaultStates.state.cart?.offers?.filter(offer => {
      if (!localStore.getLocalStorage('STANDALONE_HANDSET'))
        return offer.baseOffer.catalogTariffPlanCode === offerCode.code;
      return 0;
    }).length;
  };
  const setSkeleton = () => {
    let cards;
    if (billpaySkeleton) {
      cards = 3;
    } else {
      cards = 2;
    }
    return cards;
  };
  // const isSecondJourney = offerCode => {
  //   if (!localStore.getLocalStorage('INCOMPLETE_CART')) {
  //     if (localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'true') {
  //       if (selectedCheck(offerCode)) return false;
  //       return true;
  //     }
  //     if (localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'false') return false;
  //     return false;
  //   }
  //   return false;
  // };
  // const offerCardSelect = offerCode => {
  //   if (!isSecondJourney(offerCode.code) && selectedCheck(offerCode)) return true;
  //   if (
  //     !isSecondJourney(offerCode.code) &&
  //     localStore.getLocalStorage('INCOMPLETE_CART') &&
  //     selectedCheck(offerCode) > 0
  //   )
  //     return true;
  //   if (
  //     isSecondJourney(offerCode.code) &&
  //     !localStore.getLocalStorage('INCOMPLETE_CART') &&
  //     selectedCheck(offerCode) > 0
  //   )
  //     return false;
  //   if (
  //     isSecondJourney(offerCode.code) &&
  //     localStore.getLocalStorage('INCOMPLETE_CART') &&
  //     selectedCheck(offerCode) > 0
  //   )
  //     return false;
  // };
  const handleLeftClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.swiper.slidePrev();
  }, []);

  const handleRightClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.swiper.slideNext();
  }, []);

  const checkArrowsStatus = () => {
    if (swiperRef.current.swiper.isBeginning) {
      setLeftArrowDisabled(true);
      // setRightArrowDisabled(false);
    }
    if (swiperRef.current.swiper.isEnd) {
      setRightArrowDisabled(true);
    }
    if (!swiperRef.current.swiper.isBeginning) {
      setLeftArrowDisabled(false);
    }
    if (!swiperRef.current.swiper.isEnd) {
      // setLeftArrowDisabled(false);
      setRightArrowDisabled(false);
    }
  };

  useEffect(() => {
    setOfferCardSelected([selectedBundle?.code]);
  }, [selectedBundle?.code]);

  // useEffect(() => {
  //   if (
  //     localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'false' &&
  //     !localStore.getLocalStorage('INCOMPLETE_CART') &&
  //     !localStore.getLocalStorage('STANDALONE_HANDSET')
  //   ) {
  //     router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/summary`);
  //   }
  // }, []);

  useEffect(() => {
    if (
      localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'false' &&
      localStore.getLocalStorage('INCOMPLETE_CART') === 'false' &&
      !localStore.getLocalStorage('STANDALONE_HANDSET')
    ) {
      router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
    }
  }, []);
  // useEffect(() => {
  //   if (!localStore.getLocalStorage('STANDALONE_HANDSET')) {
  //     if (
  //       !localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') ||
  //       localStore.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') !== 'true'
  //     ) {
  //       setOfferCardSelected(
  //         // eslint-disable-next-line array-callback-return
  //         defaultStates.state?.cart?.offers?.map(item => {
  //           if (item.baseOffer.serviceGroup === 'MOBILE')
  //             return item.baseOffer.catalogTariffPlanCode;
  //         })
  //       );
  //     }
  //   }
  // }, [defaultStates.state]);

  const handleKeydown = e => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      e.target.click();
    }
  };

  const updatePaginationDots = swiper => {
    const paginationDots = swiper.el?.querySelectorAll('.swiper-pagination-bullet');
    if (!paginationDots || !paginationDots.length) return;

    const activeIndex = swiper.realIndex ?? swiper.activeIndex ?? 0;

    paginationDots.forEach((dot, i) => {
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');

      dot.removeEventListener('keydown', handleKeydown);
      dot.addEventListener('keydown', handleKeydown);

      if (i === activeIndex) {
        dot.setAttribute('aria-label', 'Current plan');
      } else if (i < activeIndex) {
        dot.setAttribute('aria-label', 'Previous plan');
      } else {
        dot.setAttribute('aria-label', 'Next plan');
      }
    });
  };
  return (
    <Container
      id='offerCardData'
      sx={
        // fadeEffect
        //   ? { mb: 2, display: 'flex', justifyContent: 'center', zIndex: 0 }
        //   :
        {
          mb: 0,
          display: 'flex',
          justifyContent: 'center',
          maxWidth: '100vw !important',
          marginLeft: '0 !important',
          marginRight: '0 !important',
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
          backgroundColor: theme.palette.secondary.contrastText,
          // isStandAloneHandset
          //   ? theme.palette.primary.lightGrey
          //   : theme.palette.secondary.contrastText,
        }
      }
    >
      {!loading && offers?.length > 0 ? (
        <Box
          sx={
            // fadeEffect
            //   ? { ...styles(theme).offerCards, ...{ zIndex: 0 } }
            //   :
            { ...(offers?.length === 1 ? styles(theme).singleOfferCard : styles(theme).offerCards) }
          }
          // style={lg && { width: '58rem' }}
          id='offerCardData'
        >
          {!md && !leftArrowDisabled && offers?.length > 3 && (
            <IconButton
              size='small'
              sx={styles(theme).prevArrow}
              onClick={handleLeftClick}
              disableRipple
              disableTouchRipple
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
          )}
          <SwiperCarousel
            settings={{
              className: 'content-carousel-mobile',
              pagination: { enable: true, clickable: true },
              modules: [Pagination],
              initialSlide: 0,
              updateOnWindowResize: true,
              slidesPerView: 'auto',
              slidesPerGroup: offers?.length > 5 && !md ? 3 : 1,
              onSlideChange: swiper => {
                checkArrowsStatus();
                updatePaginationDots(swiper);
              },
              breakpoints: {
                320: {
                  slidesPerView: 1,
                },
                600: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
              },
              onAfterInit: swiper => {
                setTimeout(() => {
                  updatePaginationDots(swiper);
                }, 100);
              },
              onPaginationUpdate: swiper => {
                updatePaginationDots(swiper);
              },
              onBreakpoint: swiper => {
                updatePaginationDots(swiper);
              },
            }}
            sliderRef={swiperRef}
            style={{
              ...style.offerSlider.swiper,
              ...(offers?.length < 3 && style.offerSlider.centerSwiper),
            }}
          >
            {offers &&
              offers.length > 0 &&
              offers.map(
                (offer, index) =>
                  ((offers?.length > 0 && xs) || offers.length > 1) && (
                    <SwiperSlide key={index}>
                      <EirOfferCard
                        headerImgDescription={offer?.headerImgDescription}
                        slideNumber={index}
                        {...offer}
                        headerImage={offer?.image}
                        afterPrice={offer.afterPrice}
                        afterPricePosition={offer.afterPricePosition?.[0]}
                        moreInfo={offer.moreInfo}
                        index={index}
                        offerSelected={
                          // localStore.getLocalStorage('INCOMPLETE_CART')
                          //   ? selectedCheck(offer) > 0
                          // :
                          offerCardSelected?.includes(offer.code)
                        }
                        offer={offer}
                        selectButton={{
                          title: 'Select Plan',
                          action:
                            // (selectedCheck(offer) !== 0 &&
                            //   offerCardSelected?.includes(offer.code)) || // to check whether added in this journey or not
                            // offerCardSelect(offer) // to check in case of second journey or incomplete journey
                            offerCardSelected?.includes(offer.code)
                              ? handleOnMobileOfferUnselect
                              : handleOnMobileOfferSelect,
                        }}
                        styleCard={{}}
                        color='primary'
                        switchTheme={simOnly}
                        useMaxHeight={useMaxHeight}
                        onOfferSelect={handleOnMobileOfferSelect}
                        onOfferUnSelect={onOfferUnSelect}
                        showCounter
                        offerCount={selectedCheck(offer)}
                        isMobile
                        code={offer.code}
                        showLoader={showLoader}
                        cmsData={cmsData}
                        // allowedToAdd={() => {
                        //   allowedToAdd();
                        // }}
                      />
                    </SwiperSlide>
                  )
              )}
          </SwiperCarousel>
          {offers &&
            offers.length > 0 &&
            offers.length === 1 &&
            !xs &&
            offers.map((offer, index) => (
              <EirSingleOfferCard
                {...offer}
                singleTariffHeaderImage={offer.singleTariffImage}
                singleHeaderImgDescription={offer.singleHeaderImgDescription}
                index={index}
                offerSelected={
                  // localStore.getLocalStorage('INCOMPLETE_CART')
                  //   ? selectedCheck(offer) > 0
                  //   :
                  offerCardSelected?.includes(offer.code)
                }
                offer={offer}
                selectButton={{
                  title: 'Select offer',
                  action:
                    // isSecondJourney(offer.code) === false &&
                    // (selectedCheck(offer) !== 0 && offerCardSelected?.includes(offer.code)) || // to check whether added in this journey or not
                    // offerCardSelect(offer) // to check in case of second journey or incomplete journey
                    offerCardSelected?.includes(offer.code)
                      ? handleOnMobileOfferUnselect
                      : handleOnMobileOfferSelect,
                }}
                styleCard={{}}
                color='primary'
                switchTheme={simOnly}
                showCounter
                offerCount={selectedCheck(offer)}
                onOfferSelect={handleOnMobileOfferSelect}
                onOfferUnSelect={onOfferUnSelect}
                code={offer.code}
                showLoader={showLoader}
                isMobile
                cmsData={cmsData}
                // allowedToAdd={() => {
                //   allowedToAdd();
                // }}
              />
            ))}
          {!md && !RightArrowDisabled && offers?.length > 3 && (
            <IconButton
              size='small'
              sx={styles(theme).nextArrow}
              onClick={handleRightClick}
              disableRipple
              disableTouchRipple
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          )}
        </Box>
      ) : (
        <Stack spacing={3} direction='row'>
          {Array(xs ? 1 : setSkeleton())
            .fill()
            .map((_, index) => (
              <EirOfferCard loading index={index} />
            ))}
        </Stack>
      )}
    </Container>
  );
};

export default EirOfferCardContainer;
